import packageInfo from '../../package.json';

export const environment = {
    production: false,
    version: `${packageInfo.version}.test`,

    mail_support: 'soporte@agentedeprensa.com',
    
    app_urls: {
        source: 'https://adp-api.hub83.cloud',
        clipping: 'https://adp-clipping.hub83.cloud',
    },

    images: {
        DEFAULT_AVATAR_PATH: './assets/images/default-avatar.png',
        DEFAULT_NO_IMAGE: './assets/images/noimage.png',
        LOGOTYPE: './assets/images/logotype.png'
    },
    
    localStorageKeys: {
        AUTH: 'AUTH_STG',
        TOKEN: 'TOKEN_STG'
    }
};
